<template>
  <section class="container">
    <div class="btn-group">
      <el-button
        type="primary"
        class="add-btn"
        @click="openAddDialog">新增</el-button>
    </div>

    <table-pagination
      :config="config"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <!-- <el-table-column sl></el-table-column> -->
      <el-table-column
        slot="filter"
        label="图片"
        align="center">
        <template slot-scope="scope">
          <img
            :src="qiniuDomain + scope.row.carousel_img"
            style="max-width: 150px; max-height:100px;">
        </template>
      </el-table-column>
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="285"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="success"
              plain
              @click="toDetail(scope.row.uuid)">详情</el-button>
            <el-button
              type="primary"
              plain
              @click="toEdit(scope.row.uuid)">编辑</el-button>
            <el-button
              type="danger"
              plain
              @click="handlerDel(scope)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </table-pagination>

    <el-dialog
      title="新增"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="500px">

      <el-form label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="editObject.carousel_title"/>
        </el-form-item>
        <el-form-item label="英文标题">
          <el-input v-model="editObject.carousel_english_title"/>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="editObject.carousel_url"/>
        </el-form-item>
        <el-form-item label="权重">
          <!-- <el-input v-model="editObject.carousel_sort"/> -->
          <el-input-number
            v-model="editObject.carousel_sort"
            :min="1" />
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadDomain"
            :data="uploadData"
            :on-success="uploadSuccess"
            :show-file-list="false">
            <img
              v-if="editObject.carousel_img"
              :src="qiniuDomain + editObject.carousel_img"
              class="avatar">
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSaveClick()">确 定</el-button>
      </span>
    </el-dialog>

  </section>
</template>

<script>
import TablePagination from '@/components/table-pagination';
// import Mixin from '@/mixins/get-qiniu'
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  slideshowList, addSlideshow, editSlideshow, delSlideshow,
} from '@/api/slideshow'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      dialogEdit: false,
      editObject: { //  根据接口来的命名，不是很喜欢---
        carousel_title: '',
        carousel_url: '',
        carousel_img: '',
        carousel_sort: '',
      },
      config: {
        // pagination: true,
        size: 5,
        fields: [
          {
            prop: 'carousel_title',
            label: '标题',
          },
          {
            prop: 'carousel_english_title',
            label: '英文标题',
          },
          {
            prop: 'carousel_url',
            label: '跳转链接',
          },
          {
            prop: 'carousel_sort',
            label: '权重',
          },
        ],
      },
      pageIndex: 1,
      datasource: {
        total: 1,
        data: [],
      },
    };
  },

  components: {
    TablePagination,
  },

  created() {
    this.network().getQiniuInfo()
    this.network().slideshowList()
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handlerPageChange(data) {
      this.pageIndex = data.page
      this.network().slideshowList()
    },
    toDetail(uuid) {
      this.$router.push({
        path: `/slideshow-detail/${uuid}`,
      })
    },
    toEdit(uuid) {
      this.$router.push({
        path: `/slideshow-edit/${uuid}`,
      })
    },
    handlerDel(data) {
      this.network().delSlideshow(data.row.uuid)
    },
    openAddDialog() {
      this.dialogType = 0
      this.editObject.carousel_title = ''
      this.editObject.carousel_url = ''
      this.editObject.carousel_sort = ''
      this.editObject.carousel_img = ''
      this.editObject.carousel_english_title = ''
      this.dialogEdit = true
    },
    handlerNavigator(scope) {
      this.$router.push({
        path: `/example-management/example-${scope.row.alias}`,
      });
    },
    uploadSuccess(res) {
      this.editObject.carousel_img = res.hash
    },
    event() {
      return {
        onSaveClick: () => {
          if (!this.event().inputVerify()) {
            return
          }
          //  dialogType: 0-新增、1-编辑
          // if (this.dialogType === 0) {
          this.network().addSlideshow()
          // } else {
          //   this.network().editSlideshow()
          // }
        },
        inputVerify: () => {
          if (!this.editObject.carousel_title) {
            this.$message('标题不能为空')
            return false
          }
          if (!this.editObject.carousel_english_title) {
            this.$message('英文标题不能为空')
            return false
          }
          // eslint-disable-next-line
          const httpReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
          if (this.editObject.carousel_url && !httpReg.test(this.editObject.carousel_url)) {
            this.$message('跳转链接格式不正确')
            return false
          }
          if (!this.editObject.carousel_sort) {
            this.$message('权重不能为空')
            return false
          }
          if (!this.editObject.carousel_img) {
            this.$message('请先上传图片')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        slideshowList: async () => {
          const { status, data } = await slideshowList({
            page_index: this.pageIndex,
            page_count: this.config.size,
          })
          if (status === 200) {
            this.datasource.total = data.data_count
            this.datasource.data = data.char
          }
        },
        addSlideshow: async () => {
          const { status } = await addSlideshow(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().slideshowList()
          }
        },
        editSlideshow: async () => {
          const { status } = await editSlideshow(this.editObject)
          if (status === 200) {
            this.dialogEdit = false
            this.network().slideshowList()
          }
        },
        delSlideshow: async (uuid) => {
          const { status } = await delSlideshow({
            uuid,
          })
          if (status === 200) {
            this.dialogEdit = false
            this.network().slideshowList()
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/slideshow/list.vue